export default "__VITE_ASSET__BNUnCIHJ__"